// src/components/Members.jsx
import React, { useEffect, useState } from "react";
import {
  adminGet,
  adminPost,
  canEditMemberFullProfile,
} from "../../../Services";
import { AgGridReact } from "ag-grid-react";
import {
  ClientSideRowModelModule,
  GridStateModule,
  RowSelectionModule,
  ModuleRegistry,
} from "ag-grid-community";
import {
  Container,
  Spinner,
  Form,
  Modal,
  Row,
  Col,
  Card,
  Button,
  Badge,
} from "react-bootstrap";
import { toast } from "react-toastify";
import ApplyDesignationModal from "./applyDesignationModal";
import EditMemberFullProfileModal from "./EditMemberFullProfileModal";
import { formatDateTime } from "../../../utils/helpers";
import { downloadExcel } from "../../../utils/excelExport";

ModuleRegistry.registerModules([
  RowSelectionModule,
  GridStateModule,
  ClientSideRowModelModule,
]);

const CERTIFIER_URL =
  process.env.REACT_APP_CERTIFIER_URL ||
  "https://certifier.duckdns.org/api/generate";
const CERTIFIER_API_KEY = process.env.REACT_APP_CERTIFIER_API_KEY || "";

const toDDMMYYYY = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return "";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

const toDDDashMMDashYYYY = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return "";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
};

const toDOJFormat = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return "";
  const dd = String(d.getDate()).padStart(2, "0");
  const month = d.toLocaleString("en-IN", { month: "long" });
  const yyyy = d.getFullYear();
  return `${dd}-${month}-${yyyy}`;
};

const getDesignationLabel = (member) => {
  const assignments = member?.DesignationAssignments || [];
  if (!assignments.length) return "MEMBER";
  const first = assignments[0];
  const scope = first?.Designation?.scope || first?.level || "";
  const name = first?.Designation?.name || "";
  return `${scope} ${name}`.trim() || "MEMBER";
};

const getWorkingArea = (member) => {
  const first = member?.DesignationAssignments?.[0];
  const scope = first?.Designation?.scope || first?.level || "";
  if (scope === "National") return "India";
  if (scope === "State") return first?.state || "";
  if (scope === "District") return first?.district || first?.state || "";
  if (scope === "Block")
    return first?.block || first?.district || first?.state || "";
  return first?.block || first?.district || first?.state || "";
};

const getAbsolutePhotoUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `https://manavadhikarforum.in${url}`;
};

const validateIdCardFields = (name, position) => {
  const messages = [];
  if ((name || "").trim().length > 32) {
    messages.push("Name must be 32 characters or less.");
  }
  if ((position || "").trim().length > 32) {
    messages.push("Designation must be 32 characters or less.");
  }
  return messages;
};

const Members = () => {
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [gridApi, setGridApi] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    sortField: "createdAt",
    sortOrder: "DESC",
  });
  const [search, setSearch] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
    approved: "",
    state: "",
    district: "",
    block: "",
    designation: "",
    regId: "",
    remarks: "",
    expiryDate: "",
    createdFrom: "",
    createdTo: "",
    updatedFrom: "",
    updatedTo: "",
    approvedFrom: "",
    approvedTo: "",
    memberSinceFrom: "",
    memberSinceTo: "",
  });
  const [showImageModal, setShowImageModal] = useState(false);
  const [activeImage, setActiveImage] = useState(null);
  const [showApplyDesignationModal, setShowApplyDesignationModal] =
    useState(false);
  const [showEditFullProfileModal, setShowEditFullProfileModal] =
    useState(false);
  const [isGeneratingDoc, setIsGeneratingDoc] = useState(false);
  const [isDownloadingExcel, setIsDownloadingExcel] = useState(false);
  const [showDocValidationModal, setShowDocValidationModal] = useState(false);
  const [docValidationMessages, setDocValidationMessages] = useState([]);
  const [customIdCardName, setCustomIdCardName] = useState("");
  const [customIdCardDesignation, setCustomIdCardDesignation] = useState("");
  const [needsNameFix, setNeedsNameFix] = useState(false);
  const [needsDesignationFix, setNeedsDesignationFix] = useState(false);
  const [showIdCardDetailsModal, setShowIdCardDetailsModal] = useState(false);
  const [idCardDetails, setIdCardDetails] = useState({
    name: "",
    position: "",
    phone: "",
    workingArea: "",
    validDate: "",
    district: "",
    statePin: "",
    vehicleNumber: "",
    idCardNumber: "",
    photoUrl: "",
  });
  const [idCardEditable, setIdCardEditable] = useState({
    name: false,
    position: false,
    phone: false,
    workingArea: false,
    validDate: false,
    district: false,
    statePin: false,
    vehicleNumber: false,
    idCardNumber: false,
    photoUrl: false,
  });

  // If the member already has at least one designation assignment, don't allow re-assigning.
  const isAlreadyAssigned = selectedData?.DesignationAssignments?.length > 0;

  const handleImageClick = (imgUrl) => {
    setActiveImage(imgUrl);
    setShowImageModal(true);
  };

  // While review modal is open, block page-level right-click.
  useEffect(() => {
    if (!showModal) return undefined;

    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    document.addEventListener("contextmenu", handleContextMenu);
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, [showModal]);

  const downloadBlob = (blob, fileName) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  const handleDownloadDocument = async (documentType, overrideData = null) => {
    if (!selectedData?.id) return;
    const defaultName = selectedData?.name || "";
    const defaultPosition = getDesignationLabel(selectedData).toUpperCase();
    const nameForCard = overrideData?.name ?? defaultName;
    const position = overrideData?.position ?? defaultPosition;
    if (documentType === "id_card") {
      const validationMessages = validateIdCardFields(nameForCard, position);
      if (validationMessages.length > 0) {
        setDocValidationMessages(validationMessages);
        setCustomIdCardName(nameForCard);
        setCustomIdCardDesignation(position);
        setNeedsNameFix((nameForCard || "").trim().length > 32);
        setNeedsDesignationFix((position || "").trim().length > 32);
        setShowDocValidationModal(true);
        return;
      }
    }
    setIsGeneratingDoc(true);
    try {
      const basePayload =
        documentType === "id_card"
          ? {
              document_type: "id_card",
              name: nameForCard,
              position,
              phone: selectedData?.mobile_no || "",
              workingArea: getWorkingArea(selectedData),
              validDate: toDDMMYYYY(selectedData?.expiry_date),
              district: `Distt-${selectedData?.district || ""}`,
              statePin: `State-${selectedData?.state || ""} Pin Code -${selectedData?.pin || ""}`,
              vehicleNumber: selectedData?.vehicle_no || " ",
              idCardNumber: selectedData?.registration_id || "",
              photoUrl: getAbsolutePhotoUrl(selectedData?.photo_url),
            }
          : {
              document_type: "certificate",
              name: selectedData?.name || "",
              regIdNumber: selectedData?.registration_id || "",
              state: selectedData?.state || "",
              doj: toDOJFormat(selectedData?.member_since),
              dob: toDDDashMMDashYYYY(selectedData?.dob),
              photoUrl: getAbsolutePhotoUrl(selectedData?.photo_url),
            };
      const payload =
        documentType === "id_card" && overrideData
          ? {
              ...basePayload,
              ...overrideData,
              vehicleNumber:
                (overrideData.vehicleNumber ?? basePayload.vehicleNumber) ||
                " ",
            }
          : basePayload;

      const res = await fetch(CERTIFIER_URL, {
        method: "POST",
        headers: {
          "x-api-key": CERTIFIER_API_KEY,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        let msg = "Failed to generate document.";
        try {
          const error = await res.json();
          msg = error?.error || error?.message || msg;
        } catch (_) {}
        toast.error(msg);
        return;
      }
      const blob = await res.blob();
      const fileName =
        documentType === "id_card"
          ? `${selectedData?.registration_id || "id_card"}.jpg`
          : `${selectedData?.registration_id || "certificate"}_certificate.jpg`;
      downloadBlob(blob, fileName);
      toast.success(
        documentType === "id_card"
          ? "ID card downloaded successfully."
          : "Certificate downloaded successfully.",
      );
    } catch (err) {
      toast.error(err?.message || "Failed to generate document.");
    } finally {
      setIsGeneratingDoc(false);
    }
  };

  const openIdCardDetailsModal = () => {
    if (!selectedData?.id) return;
    const details = {
      name: selectedData?.name || "",
      position: getDesignationLabel(selectedData).toUpperCase(),
      phone: selectedData?.mobile_no || "",
      workingArea: getWorkingArea(selectedData),
      validDate: toDDMMYYYY(selectedData?.expiry_date),
      district: `Distt-${selectedData?.district || ""}`,
      statePin: `State-${selectedData?.state || ""} Pin Code -${selectedData?.pin || ""}`,
      vehicleNumber: selectedData?.vehicle_no || " ",
      idCardNumber: selectedData?.registration_id || "",
      photoUrl: getAbsolutePhotoUrl(selectedData?.photo_url),
    };
    setIdCardDetails(details);
    setIdCardEditable({
      name: false,
      position: false,
      phone: false,
      workingArea: false,
      validDate: false,
      district: false,
      statePin: false,
      vehicleNumber: false,
      idCardNumber: false,
      photoUrl: false,
    });
    setShowIdCardDetailsModal(true);
  };

  // const fetchMembers = () => {
  //   adminGet("/api/members/admin/getMembers")
  //     .then((res) => {
  //       setRowData(res.data.data);
  //       console.log(res.data.data);
  //       // setPagination({
  //       //   page: res.data.page,
  //       //   limit: res.data.limit,
  //       //   total: res.data.total,
  //       // });
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  const fetchMembers = () => {
    const searchTerm = search.trim();
    const appliedSearch = searchTerm.length >= 3 ? searchTerm : "";

    const query = new URLSearchParams({
      page: pagination.page,
      limit: pagination.limit,
      ...(appliedSearch ? { name: appliedSearch } : {}),
      ...(filters.approved ? { approved: filters.approved } : {}),
      ...(filters.state ? { state: filters.state } : {}),
      ...(filters.district ? { district: filters.district } : {}),
      ...(filters.block ? { block: filters.block } : {}),
      ...(filters.designation ? { designation: filters.designation } : {}),
      ...(filters.regId ? { regId: filters.regId } : {}),
      ...(filters.remarks ? { remarks: filters.remarks } : {}),
      ...(filters.expiryDate ? { expiryDate: filters.expiryDate } : {}),
      ...(filters.createdFrom ? { createdFrom: filters.createdFrom } : {}),
      ...(filters.createdTo ? { createdTo: filters.createdTo } : {}),
      ...(filters.updatedFrom ? { updatedFrom: filters.updatedFrom } : {}),
      ...(filters.updatedTo ? { updatedTo: filters.updatedTo } : {}),
      ...(filters.approvedFrom ? { approvedFrom: filters.approvedFrom } : {}),
      ...(filters.approvedTo ? { approvedTo: filters.approvedTo } : {}),
      ...(pagination.sortField ? { sortBy: pagination.sortField } : {}),
      ...(pagination.sortOrder ? { sortOrder: pagination.sortOrder } : {}),
      ...(filters.memberSinceFrom
        ? { memberSinceFrom: filters.memberSinceFrom }
        : {}),
      ...(filters.memberSinceTo
        ? { memberSinceTo: filters.memberSinceTo }
        : {}),
    }).toString();

    setLoading(true);
    adminGet(`/api/members/admin/getMembers?${query}`)
      .then((res) => {
        setRowData(res.data.data || []);
        setPagination((p) => ({ ...p, total: res.data.total || 0 }));
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  };

  const handleDownloadAllData = async () => {
    setIsDownloadingExcel(true);
    try {
      const searchTerm = search.trim();
      const appliedSearch = searchTerm.length >= 3 ? searchTerm : "";

      // Fetch all data by setting a very high limit or via a dedicated endpoint if available.
      // Based on fetchMembers, we'll use a large limit to get everything matching current filters.
      const query = new URLSearchParams({
        page: 1,
        limit: 10000, // Large limit to get all records
        ...(appliedSearch ? { name: appliedSearch } : {}),
        ...(filters.approved ? { approved: filters.approved } : {}),
        ...(filters.state ? { state: filters.state } : {}),
        ...(filters.district ? { district: filters.district } : {}),
        ...(filters.block ? { block: filters.block } : {}),
        ...(filters.designation ? { designation: filters.designation } : {}),
        ...(filters.regId ? { regId: filters.regId } : {}),
        ...(filters.remarks ? { remarks: filters.remarks } : {}),
        ...(filters.expiryDate ? { expiryDate: filters.expiryDate } : {}),
        ...(filters.createdFrom ? { createdFrom: filters.createdFrom } : {}),
        ...(filters.createdTo ? { createdTo: filters.createdTo } : {}),
        ...(filters.updatedFrom ? { updatedFrom: filters.updatedFrom } : {}),
        ...(filters.updatedTo ? { updatedTo: filters.updatedTo } : {}),
        ...(filters.approvedFrom ? { approvedFrom: filters.approvedFrom } : {}),
        ...(filters.approvedTo ? { approvedTo: filters.approvedTo } : {}),
        ...(pagination.sortField ? { sortBy: pagination.sortField } : {}),
        ...(pagination.sortOrder ? { sortOrder: pagination.sortOrder } : {}),
        ...(filters.memberSinceFrom
          ? { memberSinceFrom: filters.memberSinceFrom }
          : {}),
        ...(filters.memberSinceTo
          ? { memberSinceTo: filters.memberSinceTo }
          : {}),
      }).toString();

      const res = await adminGet(`/api/members/admin/getMembers?${query}`);
      const allData = res.data.data || [];

      if (allData.length === 0) {
        toast.info("No data available to download.");
        return;
      }

      

      // Format data for Excel
      const excelData = allData.map((m) => {
        const isExpired = m.expiry_date && new Date(m.expiry_date) < new Date();
        return {
        "Reg ID": m.registration_id || "N/A",
        Name: m.name || "N/A",
        Mobile: m.mobile_no || "N/A",
        Email: m.email || "N/A",
        Approved: m.approved ? "Yes" : "No",
        Designation: getDesignationLabel(m),
        "Working Area": getWorkingArea(m),
        State: m.state || "N/A",
        District: m.district || "N/A",
        Block: m.block || "N/A",
        "Member Since": toDDMMYYYY(m.member_since),
        "Expiry Date": toDDMMYYYY(m.expiry_date),
        "Created At": formatDateTime(m.createdAt),
        Remarks: m.remarks || "",
        _isExpired: isExpired,
      }
      });

      const applyRowStyles = (row, rowData) => {
        if (rowData._isExpired) {
          row.eachCell((cell) => {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFFF0000" }, // Red Background
            };
            cell.font = {
              color: { argb: "FFFFFFFF" }, // White Text
              bold: true,
            };
          });
        }
      };

      downloadExcel(
        excelData,
        `Members_Export_${new Date().toISOString().split("T")[0]}`,
        "Members",
        applyRowStyles
      );
      toast.success("Excel file downloaded successfully.");
    } catch (err) {
      console.error(err);
      toast.error("Failed to download data.");
    } finally {
      setIsDownloadingExcel(false);
    }
  };

  const handleApproveMember = () => {
    setLoading(true);
    adminPost(`/api/members/admin/approve/${selectedData.id}`)
      .then((res) => {
        fetchMembers();
        toast.success("Member approved successfully!");
        setSelectedData((prev) => ({
          ...prev,
          approved: true,
        }));
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.response.data.error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // useEffect(() => {
  //   console.log(pagination.page, pagination.limit);
  //   fetchMembers();
  // }, [pagination.page, pagination.limit]);
  useEffect(() => {
    fetchMembers();
  }, [
    pagination.page,
    pagination.limit,
    pagination.sortField,
    pagination.sortOrder,
    search,
    filters,
  ]);

  const columnDefs = [
    {
      headerName: "Approved",
      field: "approved",
      sortable: true,
      width: 100,
      cellRenderer: (params) =>
        params.value ? (
          <div style={{ textAlign: "center" }}>
            <i
              className="bi bi-circle-fill"
              style={{ fontSize: "1rem", color: "green" }}
            ></i>
          </div>
        ) : (
          <div style={{ textAlign: "center" }}>
            <i
              className="bi bi-circle-fill"
              style={{ fontSize: "1rem", color: "red" }}
            ></i>
          </div>
        ),
    },
    { headerName: "Reg ID", field: "registration_id", sortable: true },
    {
      headerName: "Designation",
      valueGetter: (params) => {
        if (
          params.data.DesignationAssignments &&
          params.data.DesignationAssignments.length > 0
        ) {
          const designation = params.data.DesignationAssignments[0];
          return `${designation.level} ${designation.Designation.name}`;
        }
        return "N/A";
      },
      sortable: true,
    },
    { headerName: "Name", field: "name", sortable: true },
    { headerName: "State", field: "state", sortable: true },
    { headerName: "District", field: "district", sortable: true },
    { headerName: "Block", field: "block", sortable: true },
    {
      headerName: "Member Since",
      field: "member_since",
      sortable: true,
      valueFormatter: (params) => formatDateTime(params.value),
    },
    {
      headerName: "Created At",
      field: "createdAt",
      sortable: true,
      valueFormatter: (params) => formatDateTime(params.value),
    },
    {
      headerName: "Updated At",
      field: "updatedAt",
      sortable: true,
      valueFormatter: (params) => formatDateTime(params.value),
    },
    { headerName: "Remarks", field: "remarks", sortable: true },
    {
      headerName: "Actions",
      field: "actions",
      cellRenderer: (params) => (
        <div
          className="text-primary"
          style={{ cursor: "pointer", textAlign: "center" }}
          onClick={() => {
            setSelectedData(params.data);
            setShowModal(true);
          }}
        >
          <i className="bi bi-eye" style={{ fontSize: "1.5rem" }}></i>
        </div>
      ),
      pinned: "right",
      width: 80,
    },
  ];

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  // const onSortChanged = () => {
  //   if (!gridApi) return;
  //   const sortModel = gridApi.getSortModel();
  //   if (sortModel.length) {
  //     setPagination((p) => ({
  //       ...p,
  //       sortField: sortModel[0].colId,
  //       sortOrder: sortModel[0].sort?.toUpperCase() === "ASC" ? "ASC" : "DESC",
  //       page: 1,
  //     }));
  //   } else {
  //     setPagination((p) => ({
  //       ...p,
  //       sortField: "createdAt",
  //       sortOrder: "DESC",
  //       page: 1,
  //     }));
  //   }
  // };

  return (
    <div className="p-2 pt-0">
      <div className="mb-2 d-flex align-items-center justify-content-between ">
        <h3 className="fw-medium" style={{ color: "#1a5276" }}>
          Members List
        </h3>
        {/* Limit Dropdown */}
        {/* <div className=" d-flex justify-content-between align-items-center">
          <Form.Select
            style={{ width: "100px" }}
            value={pagination.limit}
            onChange={(e) =>
              setPagination({ ...pagination, limit: parseInt(e.target.value) })
            }
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
          </Form.Select>
          {/* <p>
            Showing page {pagination.page} of{" "}
            {Math.ceil(pagination.total / pagination.limit) || 1}
          </p> 
        </div> */}
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <Form.Control
              type="text"
              placeholder="Search members..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPagination((p) => ({ ...p, page: 1 }));
              }}
              style={{ width: "250px", marginRight: 10 }}
            />
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => setShowFilters(true)}
              style={{ marginRight: 10 }}
            >
              <i className="bi bi-funnel"></i> Filters
            </Button>
            <Button
              variant="success"
              size="sm"
              onClick={handleDownloadAllData}
              disabled={isDownloadingExcel}
              style={{ marginRight: 10 }}
            >
              {isDownloadingExcel ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-1"
                  />
                  Downloading...
                </>
              ) : (
                <>
                  <i className="bi bi-file-earmark-excel me-1"></i> Download
                  Data
                </>
              )}
            </Button>
          </div>
          <Form.Select
            style={{ width: "100px" }}
            value={pagination.limit}
            onChange={(e) =>
              setPagination((p) => ({
                ...p,
                limit: parseInt(e.target.value),
                page: 1,
              }))
            }
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </Form.Select>
        </div>
      </div>

      {/* Active filter badges */}
      <div className="mt-2">
        {Object.entries(filters).map(([k, v]) =>
          v ? (
            <Badge
              key={k}
              bg="info"
              className="me-1"
              style={{ cursor: "pointer" }}
              onClick={() => setFilters({ ...filters, [k]: "" })}
            >
              {k}: {v} ✕
            </Badge>
          ) : null,
        )}
      </div>

      <div className="position-relative">
        {loading && (
          <div className="d-flex justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100 bg-white bg-opacity-75">
            <Spinner animation="border" variant="primary" />
          </div>
        )}

        <div
          className="ag-theme-alpine"
          style={{ height: "80vh", width: "100%" }}
        >
          <AgGridReact
            columnDefs={columnDefs}
            rowModelType="clientSide"
            rowData={rowData}
            cacheBlockSize={pagination.limit}
            pagination={true}
            paginationPageSize={pagination.limit}
            onGridReady={onGridReady}
            // onSortChanged={onSortChanged}
            overlayLoadingTemplate='<span class="ag-overlay-loading-center">Loading...</span>'
            overlayNoRowsTemplate='<span class="ag-overlay-no-rows-center">No records found.</span>'
          />
          <div className="d-flex justify-content-between align-items-center">
            <Button
              variant="outline-secondary"
              disabled={pagination.page === 1}
              onClick={() => setPagination((p) => ({ ...p, page: p.page - 1 }))}
            >
              Previous
            </Button>
            <span>
              Page {pagination.page} of{" "}
              {Math.ceil((pagination.total || 0) / pagination.limit) || 1}
            </span>
            <Button
              variant="outline-secondary"
              disabled={pagination.page * pagination.limit >= pagination.total}
              onClick={() => setPagination((p) => ({ ...p, page: p.page + 1 }))}
            >
              Next
            </Button>
          </div>
        </div>
      </div>

      {/*Modal*/}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
        className="application-review-modal"
      >
        <Modal.Header closeButton className="modal-header-custom">
          <Modal.Title>
            <i className="bi bi-clipboard-check me-2"></i>
            Review Application
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="p-0"
          style={{ userSelect: "none", WebkitUserSelect: "none" }}
          onCopy={(e) => e.preventDefault()}
          onCut={(e) => e.preventDefault()}
          onPaste={(e) => e.preventDefault()}
          onContextMenu={(e) => e.preventDefault()}
          onSelectStart={(e) => e.preventDefault()}
          onDragStart={(e) => e.preventDefault()}
          onKeyDown={(e) => {
            if (
              (e.ctrlKey || e.metaKey) &&
              ["c", "x", "a"].includes(e.key.toLowerCase())
            ) {
              e.preventDefault();
            }
          }}
        >
          <Row className="g-0">
            <Col md={8} className="p-4">
              <div className="section-title fs-5">
                <i className="bi bi-person-badge me-2"></i>
                Personal Information
              </div>

              <Row>
                <Col sm={6}>
                  <div className="data-field">
                    <label>Full Name</label>
                    <p>{selectedData.name || "Not provided"}</p>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="data-field">
                    <label>Date of Birth</label>
                    <p>{selectedData.dob || "Not provided"}</p>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col sm={6}>
                  <div className="data-field">
                    <label>Profession</label>
                    <p>{selectedData.profession || "Not provided"}</p>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="data-field">
                    <label>Mobile Number</label>
                    <p>{selectedData.mobile_no || "Not provided"}</p>
                  </div>
                </Col>
              </Row>

              <div className="data-field">
                <label>Email Address</label>
                <p>{selectedData.email || "Not provided"}</p>
              </div>

              <div className="section-title mt-4 fs-5">
                <i className="bi bi-geo-alt me-2"></i>
                Address Details
              </div>

              <Row>
                <Col sm={6}>
                  <div className="data-field">
                    <label>State</label>
                    <p>{selectedData.state || "Not provided"}</p>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="data-field">
                    <label>District</label>
                    <p>{selectedData.district || "Not provided"}</p>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col sm={6}>
                  <div className="data-field">
                    <label>Block</label>
                    <p>{selectedData.block || "Not provided"}</p>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="data-field">
                    <label>PIN Code</label>
                    <p>{selectedData.pin || "Not provided"}</p>
                  </div>
                </Col>
              </Row>

              <div className="section-title mt-4 fs-5">
                <i className="bi bi-card-checklist me-2"></i>
                Identification & Documents
              </div>

              <Row>
                <Col sm={6}>
                  <div className="data-field">
                    <label>Aadhaar Number</label>
                    <p>{selectedData.aadhaar_no || "Not provided"}</p>
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="data-field">
                    <label>Vehicle No</label>
                    <p>{selectedData.vehicle_no || "Not provided"}</p>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm={6}>
                  <div className="data-field">
                    <label>Membership Expiry Date</label>
                    <p>{selectedData.expiry_date || "Not provided"}</p>
                  </div>
                </Col>
              </Row>
            </Col>

            <Col md={4} className="documents-sidebar">
              <div className="p-3">
                <h6 className="text-center mb-3">
                  <i className="bi bi-images me-2"></i>
                  Uploaded Documents
                </h6>

                {selectedData.photo_url && (
                  <Card className="mb-3 document-card">
                    <Card.Header className="text-center">
                      Profile Photo
                    </Card.Header>
                    <Card.Body className="text-center p-2">
                      <img
                        src={`${selectedData.photo_url}`}
                        alt="Profile"
                        className="uploaded-image"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          handleImageClick(`${selectedData.photo_url}`)
                        }
                      />
                    </Card.Body>
                  </Card>
                )}

                {selectedData.aadhaar_url && (
                  <Card className="document-card">
                    <Card.Header className="text-center">
                      Aadhaar Card
                    </Card.Header>
                    <Card.Body className="text-center p-2">
                      <img
                        src={`${selectedData.aadhaar_url}`}
                        alt="Aadhaar Card"
                        className="uploaded-image"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          handleImageClick(`${selectedData.aadhaar_url}`)
                        }
                      />
                    </Card.Body>
                  </Card>
                )}

                {!selectedData.photo_url && !selectedData.aadhaar_url && (
                  <div className="text-center text-muted py-4">
                    <i className="bi bi-inbox display-4"></i>
                    <p>No documents uploaded</p>
                  </div>
                )}

                <div className="d-grid gap-2 mt-3">
                  <Button
                    variant="outline-primary"
                    onClick={openIdCardDetailsModal}
                    className="fw-semibold"
                  >
                    <i className="bi bi-download me-1"></i> Download ID Card
                  </Button>
                  <Button
                    variant="outline-secondary"
                    onClick={() => handleDownloadDocument("certificate")}
                    className="fw-semibold"
                  >
                    <i className="bi bi-download me-1"></i> Download Certificate
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="modal-footer-custom d-flex flex-wrap align-items-center gap-2">
          {canEditMemberFullProfile() && (
            <Button
              variant="outline-primary"
              onClick={() => setShowEditFullProfileModal(true)}
              className="px-3"
            >
              <i className="bi bi-pencil-square me-1"></i>
              Edit full profile
            </Button>
          )}
          <div className="ms-auto d-flex flex-wrap gap-2 align-items-center">
            <Button
              variant="outline-secondary"
              onClick={() => setShowModal(false)}
              className="px-4"
            >
              <i className="bi bi-x-circle me-1"></i> Close
            </Button>
            <Button
              disabled={selectedData.approved}
              variant="success"
              onClick={handleApproveMember}
              className="d-flex align-items-center fw-semibold px-4"
            >
              <i className="bi bi-check2-circle me-2"></i>
              {selectedData.approved ? "Approved" : "Approve Member"}
            </Button>
            {selectedData.approved && (
              <Button
                variant={isAlreadyAssigned ? "secondary" : "primary"}
                disabled={isAlreadyAssigned}
                onClick={() => {
                  if (!isAlreadyAssigned) setShowApplyDesignationModal(true);
                }}
              >
                <i className="bi bi-clipboard-check me-2"></i>
                {isAlreadyAssigned ? "Assigned" : "Assign Designation"}
              </Button>
            )}
          </div>
        </Modal.Footer>
      </Modal>

      {/* Image Preview Modal */}
      <Modal
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        size="lg"
        centered
      >
        <Modal.Body className="text-center">
          <img
            src={activeImage}
            alt="Preview"
            style={{ maxWidth: "100%", maxHeight: "80vh" }}
          />
        </Modal.Body>
      </Modal>

      <ApplyDesignationModal
        show={showApplyDesignationModal}
        onHide={() => setShowApplyDesignationModal(false)}
        memberId={selectedData.id}
        onSuccess={() => {
          fetchMembers();
        }}
      />

      <EditMemberFullProfileModal
        show={showEditFullProfileModal}
        onHide={() => setShowEditFullProfileModal(false)}
        member={selectedData}
        onSuccess={(updatedMember) => {
          if (updatedMember) {
            setSelectedData(updatedMember);
          }
          fetchMembers();
        }}
      />

      <Modal show={isGeneratingDoc} centered backdrop="static" keyboard={false}>
        <Modal.Body className="text-center py-4">
          <Spinner animation="border" variant="primary" />
          <p className="mt-3 mb-0">Generating image, please wait...</p>
        </Modal.Body>
      </Modal>

      {/* ID Card Details Review/Edit Modal */}
      <Modal
        show={showIdCardDetailsModal}
        onHide={() => setShowIdCardDetailsModal(false)}
        centered
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Review ID Card Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="g-2">
              {[
                { key: "name", label: "Name", max: 32 },
                { key: "position", label: "Designation", max: 32 },
                { key: "phone", label: "Phone" },
                { key: "workingArea", label: "Working Area" },
                { key: "validDate", label: "Validity Date (DD/MM/YYYY)" },
                { key: "district", label: "District (prefixed with Distt-)" },
                { key: "statePin", label: "State + Pin" },
                { key: "vehicleNumber", label: "Vehicle Number" },
                { key: "idCardNumber", label: "ID Card Number" },
              ].map((field) => (
                <Col md={6} key={field.key}>
                  <Form.Group className="mb-1">
                    <Form.Label className="d-flex justify-content-between align-items-center">
                      <span>
                        {field.label}
                        {field.max ? ` (max ${field.max} chars)` : ""}
                      </span>
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={() =>
                          setIdCardEditable((prev) => ({
                            ...prev,
                            [field.key]: !prev[field.key],
                          }))
                        }
                      >
                        <i className="bi bi-pencil-square me-1"></i>
                        {idCardEditable[field.key] ? "Lock" : "Edit"}
                      </Button>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      disabled={!idCardEditable[field.key]}
                      value={idCardDetails[field.key] || ""}
                      onChange={(e) =>
                        setIdCardDetails((prev) => ({
                          ...prev,
                          [field.key]:
                            field.key === "position"
                              ? e.target.value.toUpperCase()
                              : e.target.value,
                        }))
                      }
                    />
                    {field.max != null && (
                      <div
                        className={
                          (idCardDetails[field.key] || "").trim().length >
                          field.max
                            ? "text-danger small mt-1"
                            : "text-success small mt-1"
                        }
                      >
                        {(idCardDetails[field.key] || "").trim().length}/
                        {field.max}
                      </div>
                    )}
                  </Form.Group>
                </Col>
              ))}
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={() => setShowIdCardDetailsModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              setShowIdCardDetailsModal(false);
              handleDownloadDocument("id_card", {
                ...idCardDetails,
                // final trim and constraints
                name: (idCardDetails.name || "").trim(),
                position: (idCardDetails.position || "").trim(),
                vehicleNumber: idCardDetails.vehicleNumber || " ",
              });
            }}
            disabled={
              !(idCardDetails.name || "").trim() ||
              !(idCardDetails.position || "").trim() ||
              (idCardDetails.name || "").trim().length > 32 ||
              (idCardDetails.position || "").trim().length > 32
            }
          >
            Generate & Download
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDocValidationModal}
        onHide={() => setShowDocValidationModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>ID Card Validation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-2">Please reduce these fields to continue:</p>
          <ul>
            {docValidationMessages.map((m, idx) => (
              <li key={idx}>{m}</li>
            ))}
          </ul>
          {needsNameFix && (
            <Form.Group className="mb-2">
              <Form.Label className="d-flex justify-content-between">
                <span>Name (max 32 chars)</span>
                <span
                  className={
                    (customIdCardName || "").trim().length > 32
                      ? "text-danger fw-semibold"
                      : "text-success"
                  }
                >
                  {(customIdCardName || "").trim().length}/32
                </span>
              </Form.Label>
              <Form.Control
                type="text"
                maxLength={60}
                value={customIdCardName}
                onChange={(e) => setCustomIdCardName(e.target.value)}
              />
            </Form.Group>
          )}
          {needsDesignationFix && (
            <Form.Group>
              <Form.Label className="d-flex justify-content-between">
                <span>Designation (max 32 chars)</span>
                <span
                  className={
                    (customIdCardDesignation || "").trim().length > 32
                      ? "text-danger fw-semibold"
                      : "text-success"
                  }
                >
                  {(customIdCardDesignation || "").trim().length}/32
                </span>
              </Form.Label>
              <Form.Control
                type="text"
                maxLength={60}
                value={customIdCardDesignation}
                onChange={(e) =>
                  setCustomIdCardDesignation(e.target.value.toUpperCase())
                }
              />
            </Form.Group>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={() => setShowDocValidationModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              setShowDocValidationModal(false);
              handleDownloadDocument("id_card", {
                name: customIdCardName.trim(),
                position: customIdCardDesignation.trim(),
              });
            }}
            disabled={
              (needsNameFix &&
                (!customIdCardName.trim() ||
                  customIdCardName.trim().length > 32)) ||
              (needsDesignationFix &&
                (!customIdCardDesignation.trim() ||
                  customIdCardDesignation.trim().length > 32))
            }
          >
            Continue Download
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Filters Modal */}
      <Modal
        show={showFilters}
        onHide={() => setShowFilters(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Filters</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md={4} className="mb-2">
                <Form.Label>Approved</Form.Label>
                <Form.Select
                  value={filters.approved}
                  onChange={(e) =>
                    setFilters({ ...filters, approved: e.target.value })
                  }
                >
                  <option value="">All</option>
                  <option value="true">Approved</option>
                  <option value="false">Not Approved</option>
                </Form.Select>
              </Col>
              <Col md={4} className="mb-2">
                <Form.Label>Registration ID</Form.Label>
                <Form.Control
                  value={filters.regId}
                  onChange={(e) =>
                    setFilters({ ...filters, regId: e.target.value })
                  }
                />
              </Col>
              <Col md={4} className="mb-2">
                <Form.Label>State</Form.Label>
                <Form.Control
                  value={filters.state}
                  onChange={(e) =>
                    setFilters({ ...filters, state: e.target.value })
                  }
                />
              </Col>
              <Col md={4} className="mb-2">
                <Form.Label>District</Form.Label>
                <Form.Control
                  value={filters.district}
                  onChange={(e) =>
                    setFilters({ ...filters, district: e.target.value })
                  }
                />
              </Col>
              <Col md={4} className="mb-2">
                <Form.Label>Block</Form.Label>
                <Form.Control
                  value={filters.block}
                  onChange={(e) =>
                    setFilters({ ...filters, block: e.target.value })
                  }
                />
              </Col>
              <Col md={4} className="mb-2">
                <Form.Label>Designation</Form.Label>
                <Form.Control
                  value={filters.designation}
                  onChange={(e) =>
                    setFilters({ ...filters, designation: e.target.value })
                  }
                />
              </Col>
              <Col md={4} className="mb-2">
                <Form.Label>Expiry Date</Form.Label>
                <Form.Control
                  type="date"
                  value={filters.expiryDate}
                  onChange={(e) =>
                    setFilters({ ...filters, expiryDate: e.target.value })
                  }
                />
              </Col>
              <Col md={12} className="mb-2">
                <Form.Label>Remarks (contains)</Form.Label>
                <Form.Control
                  value={filters.remarks}
                  onChange={(e) =>
                    setFilters({ ...filters, remarks: e.target.value })
                  }
                />
              </Col>
            </Row>

            <hr className="my-2" />
            <Row>
              <Col md={3} className="mb-2">
                <Form.Label>Created From</Form.Label>
                <Form.Control
                  type="date"
                  value={filters.createdFrom}
                  onChange={(e) =>
                    setFilters({ ...filters, createdFrom: e.target.value })
                  }
                />
              </Col>
              <Col md={3} className="mb-2">
                <Form.Label>Created To</Form.Label>
                <Form.Control
                  type="date"
                  value={filters.createdTo}
                  onChange={(e) =>
                    setFilters({ ...filters, createdTo: e.target.value })
                  }
                />
              </Col>
              <Col md={3} className="mb-2">
                <Form.Label>Updated From</Form.Label>
                <Form.Control
                  type="date"
                  value={filters.updatedFrom}
                  onChange={(e) =>
                    setFilters({ ...filters, updatedFrom: e.target.value })
                  }
                />
              </Col>
              <Col md={3} className="mb-2">
                <Form.Label>Updated To</Form.Label>
                <Form.Control
                  type="date"
                  value={filters.updatedTo}
                  onChange={(e) =>
                    setFilters({ ...filters, updatedTo: e.target.value })
                  }
                />
              </Col>
              <Col md={3} className="mb-2">
                <Form.Label>Approved From</Form.Label>
                <Form.Control
                  type="date"
                  value={filters.approvedFrom}
                  onChange={(e) =>
                    setFilters({ ...filters, approvedFrom: e.target.value })
                  }
                />
              </Col>
              <Col md={3} className="mb-2">
                <Form.Label>Approved To</Form.Label>
                <Form.Control
                  type="date"
                  value={filters.approvedTo}
                  onChange={(e) =>
                    setFilters({ ...filters, approvedTo: e.target.value })
                  }
                />
              </Col>
              <Col md={3} className="mb-2">
                <Form.Label>Since From</Form.Label>
                <Form.Control
                  type="date"
                  value={filters.memberSinceFrom}
                  onChange={(e) =>
                    setFilters({ ...filters, memberSinceFrom: e.target.value })
                  }
                />
              </Col>
              <Col md={3} className="mb-2">
                <Form.Label>Since To</Form.Label>
                <Form.Control
                  type="date"
                  value={filters.memberSinceTo}
                  onChange={(e) =>
                    setFilters({ ...filters, memberSinceTo: e.target.value })
                  }
                />
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={() =>
              setFilters({
                approved: "",
                state: "",
                district: "",
                block: "",
                designation: "",
                regId: "",
                remarks: "",
                expiryDate: "",
                createdFrom: "",
                createdTo: "",
                updatedFrom: "",
                updatedTo: "",
                approvedFrom: "",
                approvedTo: "",
              })
            }
          >
            Clear
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              setPagination((p) => ({ ...p, page: 1 }));
              setShowFilters(false);
            }}
          >
            Apply
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Members;
